import React, { useState, useEffect } from 'react'
import { RefreshCw, X } from 'lucide-react'

export const ServiceWorkerUpdatePrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)

  useEffect(() => {
    // 检查是否需要显示更新提示
    const checkForUpdate = () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistration().then(registration => {
          if (registration && registration.waiting) {
            setShowPrompt(true)
          }
        })
      }
    }

    checkForUpdate()

    // 监听 Service Worker 更新
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        setShowPrompt(false)
        // 页面将自动刷新
      })
    }
  }, [])

  const handleUpdate = async () => {
    setIsUpdating(true)
    
    try {
      // 获取 Service Worker 注册
      const registration = await navigator.serviceWorker.getRegistration()
      
      if (registration && registration.waiting) {
        // 发送跳过等待消息
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }
    } catch (error) {
      console.error('更新 Service Worker 失败:', error)
      setIsUpdating(false)
    }
  }

  if (!showPrompt) return null

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md">
      <div className="bg-gradient-to-r from-primary to-secondary rounded-lg shadow-2xl p-4 border border-white/20 backdrop-blur-sm">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0">
            <RefreshCw size={24} className="text-white" />
          </div>
          <div className="flex-1">
            <h3 className="text-white font-bold mb-1">发现新版本</h3>
            <p className="text-white/90 text-sm mb-3">
              新版本修复了图片加载问题，点击更新以应用修复
            </p>
            <div className="flex gap-2">
              <button
                onClick={handleUpdate}
                disabled={isUpdating}
                className="px-4 py-2 bg-white text-primary rounded-lg font-medium hover:bg-white/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm"
              >
                {isUpdating ? '更新中...' : '立即更新'}
              </button>
              <button
                onClick={() => setShowPrompt(false)}
                className="px-4 py-2 bg-white/20 text-white rounded-lg font-medium hover:bg-white/30 transition-colors text-sm"
              >
                稍后
              </button>
            </div>
          </div>
          <button
            onClick={() => setShowPrompt(false)}
            className="flex-shrink-0 text-white/70 hover:text-white transition-colors"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  )
}

